<template>
  <div class="fill-height responsability-page">
    <transition mode="out-in">
      <div v-if="ResponsibilityPage"  key="loaded">
          <PanoHeader
            :current-section="internal"
            :designer-conscius-title="ResponsibilityPage && ResponsibilityPage.consciousnessDesignersTitle"
            :how-to-title="ResponsibilityPage && ResponsibilityPage.howtoTitle"
            :how-to-subtitle="ResponsibilityPage && ResponsibilityPage.howToSubtitle"
            v-on:catClick="setCurrentSection"
            v-if="$vuetify.breakpoint.smAndUp"
          />
          <SplitHeader v-else
          :current-section="internal"
          :designer-conscius-title="ResponsibilityPage && ResponsibilityPage.consciousnessDesignersTitle"
          :how-to-title="ResponsibilityPage && ResponsibilityPage.howtoTitle"
          :how-to-subtitle="ResponsibilityPage && ResponsibilityPage.howToSubtitle"
          />
          <DesignersResponsibility
            :responsability-data="ResponsibilityPage"
            :current-section="internal"
            :designers="ListConsciousnessDesigners && ListConsciousnessDesigners.items"
            v-on:catClick="setCurrentSectionAfterScroll"
          />
      </div>
      <v-row v-else class="fill-height" align="center" justify="center" key="loading">
        <v-col class="shrink"><LoadingSpinner /></v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import GetResponsibilityPage from '@/graphql/GetResponsibilityPage.gql'
import ListConsciousnessDesignerEN from '@/graphql/ListConsciousnessDesigner_EN.gql'
import ListConsciousnessDesignerIT from '@/graphql/ListConsciousnessDesigner_IT.gql'
import DesignersResponsibility from '@/organisms/DesignersResponsibility'
import Section from '@/constants/responsabilitySection'
import PanoHeader from '@/molecules/PanoHeader'
import SplitHeader from '@/molecules/SplitHeader'
import LoadingSpinner from '@/atoms/LoadingSpinner'
import anime from 'animejs'

export default {
  name: 'DesignersPage',
  components: {
    SplitHeader,
    PanoHeader,
    DesignersResponsibility,
    LoadingSpinner
  },
  data () {
    return {
      currentSection: this.currentsection || null,
      section: Section,
      ConsciousnessDesigners: null,
      localizedQueries: {
        en: {
          list: ListConsciousnessDesignerEN
        },
        it: {
          list: ListConsciousnessDesignerIT
        }
      }
    }
  },
  props: {
    currentsection: {
      type: String
    },
    internal: {
      type: String
    }
  },
  watch: {
    internal (value) {
      if (!value) return
      // if (value === Section.howTO) this.$root.$emit('scroll-to-saved-position')
      this.$root.$emit('scroll-to-saved-position')
      document.documentElement.scrollTop = 0
      document.documentElement.pageYOffset = 0
      setTimeout(this.reveal, 1000)
    }
  },
  apollo: {
    ResponsibilityPage: {
      query: GetResponsibilityPage,
      skip: false,
      variables () {
        return {
          slug: this.$language.current,
          status: 'PUBLISHED'
        }
      }
    },
    ListConsciousnessDesigners: {
      query () {
        return this.localizedQueries[this.$language.current].list
      },
      skip () {
        return this.internal !== Section.consciuousDesigner
      },
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: '_slug',
          descending: false
        }
      },
      result () {
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  },
  computed: {
    // Inutile ma aspetto a toglierlo
    /* isConsciousnessDesignersVisible () {
      return !!(this.currentSection === Section.consciuousDesiginer && this.$apollo.queries.ListConsciousnessDesigners)
    } */
  },
  methods: {
    setCurrentSection (value) {
      this.currentSection = value
    },
    reveal () {
      const currentScrollOffset = window.pageYOffset || document.documentElement.scrollTop
      const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement
      anime({
        targets: scrollElement,
        scrollTop: currentScrollOffset + 400,
        duration: 500,
        easing: 'easeInOutQuad'
      })
    },
    setCurrentSectionAfterScroll (value) {
      /* window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      window.onscroll = (e) => {
        const currentScrollOffset = window.pageYOffset || document.documentElement.scrollTop
        if (currentScrollOffset === 0) {
          window.onScroll = null // remove listener
          this.currentSection = value
        }
      } */
    }
  },
  metaInfo () {
    const pageName = 'designers'
    const imageMeta = JSON.parse(this.$root.siteSettings[`${pageName}PageShareImage`].metaData)
    return {
      // home page browser title
      title: this.$root.siteSettings[`${pageName}PageTitle`],
      meta: [
        { vmid: 'description', name: 'description', content: this.$root.siteSettings[`${pageName}PageShareDescription`] },
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.$root.siteSettings[`${pageName}PageTitle`]} | ${this.$root.siteSettings.siteTitle}` },
        { vmid: 'ogdescription', property: 'og:description', content: this.$root.siteSettings[`${pageName}PageShareDescription`] },
        { vmid: 'ogimage', property: 'og:image', content: `https://${this.$root.process.env.SERVICE_TARGET_DOMAIN}/media/${this.$root.siteSettings[`${pageName}PageShareImage`].id}` },
        { vmid: 'ogimagetype', property: 'og:image:type', content: this.$root.siteSettings[`${pageName}PageShareImage`].mimeType },
        { vmid: 'ogimageheight', property: 'og:image:width', content: imageMeta['image-width'] },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: imageMeta['image-height'] }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .responsability-page {
    overflow-x: hidden;
  }
</style>
